import { AuthMethod } from "../generated/ups/graphql";
import {
  ArrayMinSize,
  IsAlpha,
  IsArray,
  IsDefined,
  IsEmail,
  IsEnum,
  IsNotEmpty,
  IsOptional,
  MaxLength,
  MinLength,
  ValidateNested,
} from "class-validator";
import { Type } from "class-transformer";

export class AttributeDto {
  @IsNotEmpty({ message: "Attribute key must not be empty" })
  key: string;

  @IsNotEmpty({ message: "Attribute value must not be empty" })
  value: string;
}

export class UserInput {
  @IsDefined({ message: "Email is a mandatory field" })
  @IsEmail(undefined, { message: "Email is not valid" })
  public email: string;

  @IsDefined({ message: "First Name is a mandatory field" })
  @IsAlpha(undefined, {
    message: "First Name must only contain letters",
  })
  @MinLength(2, {
    message: "First Name must be at least 2 characters long",
  })
  @MaxLength(50, {
    message: "First Name must be at most 50 characters long",
  })
  public firstName: string;

  @IsDefined({ message: "Last Name is a mandatory field" })
  @IsAlpha(undefined, {
    message: "Last Name must only contain letters",
  })
  @MinLength(2, {
    message: "Last Name must be at least 2 characters long",
  })
  @MaxLength(50, {
    message: "Last Name must be at most 50 characters long",
  })
  public lastName: string;

  @IsDefined({ message: "Auth Method is a mandatory field" })
  @IsEnum(AuthMethod, {
    message: "Authentication Method is not valid",
  })
  public authMethod: AuthMethod;

  @IsArray({ message: "Groups must be a comma separated list" })
  @ArrayMinSize(1, { message: "At least one group must be specified" })
  public groups: string[];

  @IsArray({ message: "Roles must be a comma separated list" })
  @ArrayMinSize(1, { message: "At least one role must be specified" })
  public roles: string[];

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => AttributeDto)
  public attributes?: AttributeDto[];
}
